export class TogglerModel {
    public show: boolean;

    constructor(show: boolean = false) {
        this.show = show;
    }

    open(): void {
        this.show = true;
    }

    close(): void {
        this.show = false;
    }
}
